export default __webpack_public_path__ + "static/media/CEM-English.02da397f.jpg";